// Page Titles
const signinTitle = "Sign In";
const callAssistantTitle = "Call Assistant";
const forgotPasswordTitle = "Forgotten Password";

// Sign in
const signIn = 'Sign In';
const signOut = 'Sign Out';
const username = 'Username';
const password = 'Password';
const close = "Close";
const helpAndSupport = "Help and Support";
const telewareHelpLink = "https://www.telewarehelp.com";
const telewareHelpLinkDisplayText = "www.telewarehelp.com";
const invalidCredentials = "Invalid username or password";
const unsuccessfulLogin = "Unable to Sign In";
const noPermissionsLoginFail = "You do not have the correct permissions to sign in.";
const initialDataLoadErrorTitle = "Failed to load initial data";
const initialDataLoadErrorContent = "Please refresh and sign in again. If this issue continues please contact your administrator.";
const registered = 'Registered';
const unregistered = 'Unregistered';
const buildNumberDescription = "Version";
const buildNumber = process.env.REACT_APP_BUILD_NO;
const checkingCredentials = "Checking Credentials...";
const launchingCCC = "Launching Cloud Contact Centre";
const clickToBecomeUnavailable = "Click to become unavailable";
const clickToBecomeAvailable = "Click to become available";
const statusTitle = "Status";
const callingFrom = "Calling From";
const call = "Call";
const enterNumberPlaceholder = "Enter a number...";
const location = "Location";
const settings = "Settings";
const locationLineOne = "Plan to receive inbound calls?";
const locationLineTwo = "You will need to add a location";
const microsoftLocation = "Microsoft Teams";

const callDetsDescDirection = "Direction";
const callDetsDescDuration = "Duration";
const callDetsDescDialledNumber = "Dialled Number";
const callDetsDescCaller = "Caller";
const callDetsDescCallInfo = "Call Information";
const callDetsDescTeamInfo = "Team Information";
const callDetsDetsOutbound = "Outbound";
const callDetsDetsInbound = "Inbound";
const callReferenceID = "Call Reference ID";

const wrapUpWarning = "Outbound calling is unavailable while in wrap-up.";

const teamMembers = "Team Members";

const changePassword = "Change password";
const usePasswordToSignInFromNowOn = "This is the password you will use\nto sign in from now on";
const currentPassword = "Current Password";
const newPassword = "New Password";
const confirmNewPassword = "Confirm New Password";
const passwordsMustContain = "Passwords must contain";
const passwordsMustMatch = "Passwords must match";

const tellUsTitle = "Tell us a little bit about you...";
const tellUsSubtitle = "We will use this information to personalise your experience and allow you to use features such as forgot password reset"
const firstName = "First Name";
const lastName = "Last Name";
const email = "Email";
const save = "Save";
const skip = "Skip";
const invalidEmail = "Invalid email";
const locations = "Locations";
const myAccount = "My Account";
const fakePassword = "••••••••";
const verified = "Verified";
const unverified = "Unverified";

const editText = "Edit";
const deleteText = "Delete";
const addLocation = "Add Location";
const editLocation = "Edit Location";
const deleteLocation = "Delete Location";
const tellUsWhereCalls = "Tell us where you want to receive calls to";

const locationName = "Location Name";
const phoneNumber = "Phone Number";
const code = "Code";
const cancel = "Cancel";
const invalidLocationCode = "Code already in use";
const failedToAddLocation = "Failed to add location. Please try again";
const addCallingLocationTitle = "Add Microsoft Teams as your calling location";
const addCallingLocationSubtitle = "Enter your Microsoft Teams phone number to receive calls";
const areYouSureDeleteLocPrefix = "Are you sure you want to delete";
const failedToDeleteLocation = "Failed to delete location. Please try again";
const unableToDelete = "We are unable to delete";
const asYouAreCurrentlyRegistered = "as you are currently registered to it.";
const ok = "Ok";
const permissionsErrorHeader = "Hold up!";
const permissionsErrorContent = "It appears that you don't have the required permissions. You're gonna need to speak to your administrator if you want access.";
const noTeamsMsg = "Oops! It appears that you haven't been added to a team. Contact your supervisor to get started.";
const errorResponseMessage = "Server returned a 403 response"

// forgotten password
const forgotYourPassword = "Forgot your password?";
const forgotYourPasswordEnterUsername = "Enter the username you use to sign in";
const forgotYourPasswordEnterEmail = "Enter the email associated with your account";
const next = "Next";
const backToSignIn = "Back to Sign In";
const enterDigitCode = "Enter 6-digit code";
const enterVerificationCode = "Enter the verification code we just sent to your email";
const incorrectCodeEntered = "Incorrect code entered";
const failedToValidate = "Failed to validate code";
const validatingCode = "Validating code";
const unableToResetPW = "Unable to reset password.";
const unableToResetPWDescription = "We were unable to reset your password. Please try again.\nIf this issue continues please contact your administrator.";
const tryAgain = "Try Again";
const failedToSave = "Failed to save changes. Please try again";
const resetPassword = "Reset password";
const resetPasswordButton = "Reset Password";

//New Password Error Messages
const passwordDoesntMatchCriteria = "Password does not meet criteria";
const passwordMustMatch = "Passwords must match";

// Welcome dialog onboarding
const getStarted = "Get Started";
const welcomeDialogSubtitle1 = "If you ever need any help or support head over to ";
const welcomeDialogSubtitle2 = "or click the Help and Support button in the profile menu.";

// Location settings email verification
const resendVerificationEmail = "Resend verification email";
const verificationFailed = "Verification failed. Try again."

const whyEmailAddress = "Why do you want my email address?";
const whyEmailAddressReason1 = "We will only use your ";
const whyEmailAddressReason2 = "verified ";
const whyEmailAddressReason3 = "email address if you forget your password and want to reset it.";

export default {
    SIGN_IN_TITLE: signinTitle,
    CALL_ASSISTANT_TITLE: callAssistantTitle,
    FORGOT_PASSWORD_TITLE: forgotPasswordTitle,

    SIGN_IN: signIn,
    SIGN_OUT: signOut,
    USERNAME: username,
    PASSWORD: password,
    CLOSE: close,
    HELP_AND_SUPPORT: helpAndSupport,
    TELEWARE_HELP_LINK: telewareHelpLink,
    TELEWARE_HELP_LINK_DISPLAY_TEXT: telewareHelpLinkDisplayText,
    INVALID_CREDENTIALS: invalidCredentials,
    UNSUCCESSFUL_LOGIN: unsuccessfulLogin,
    NO_PERMISSIONS_LOGIN: noPermissionsLoginFail,
    INITIAL_DATA_LOAD_ERROR_TITLE: initialDataLoadErrorTitle,
    INITIAL_DATA_LOAD_ERROR_CONTENT: initialDataLoadErrorContent,
    REGISTERED: registered,
    UNREGISTERED: unregistered,
    BUILD_NUMBER_TEXT: buildNumberDescription + ' ' + buildNumber,
    CHECKING_CREDENTIALS: checkingCredentials,
    LAUNCHING_CCC: launchingCCC,
    CLICK_TO_BECOME_UNAVAILABLE: clickToBecomeUnavailable,
    CLICK_TO_BECOME_AVAILABLE: clickToBecomeAvailable,
    LOCATION: location,
    SETTINGS: settings,
    LOCATION_LINE_ONE: locationLineOne,
    LOCATION_LINE_TWO: locationLineTwo,
    MICROSOFT_LOCATION: microsoftLocation,

    CALL_DETS_DESC_DIRECTION: callDetsDescDirection,
    CALL_DETS_DESC_DURATION: callDetsDescDuration,
    CALL_DETS_DESC_DIALLED_NUM: callDetsDescDialledNumber,
    CALL_DETS_DESC_CALLER: callDetsDescCaller,
    CALL_DETS_DESC_CALL_INFO: callDetsDescCallInfo,
    CALL_DETS_DESC_TEAM_INFO: callDetsDescTeamInfo,
    CALL_DETS_DESC_REFERENCE_ID: callReferenceID,
    CALL_DETS_DETS_OUTBOUND: callDetsDetsOutbound,
    CALL_DETS_DETS_INBOUND: callDetsDetsInbound,
    STATUS_TITLE: statusTitle,
    CALLING_FROM: callingFrom,
    CALL: call,
    ENTER_NUMBER_PLACEHOLDER: enterNumberPlaceholder,

    WRAP_UP_WARNING: wrapUpWarning,
    TEAM_MEMBERS: teamMembers,

    CHANGE_PASSWORD: changePassword,
    USE_PASSWORD_TO_SIGN_IN_FROM_NOW_ON: usePasswordToSignInFromNowOn,
    CURRENT_PASSWORD: currentPassword,
    NEW_PASSWORD: newPassword,
    CONFIRM_NEW_PASSWORD: confirmNewPassword,
    PASSWORDS_MUST_CONTAIN: passwordsMustContain,
    PASSWORDS_MUST_MATCH: passwordsMustMatch,

    TELL_US_ABOUT_YOU_TITLE: tellUsTitle,
    TELL_US_ABOUT_YOU_SUBTITLE: tellUsSubtitle,
    FIRSTNAME: firstName,
    LASTNAME: lastName,
    EMAIL: email,
    SAVE: save,
    SKIP: skip,
    INVALID_EMAIL: invalidEmail,
    LOCATIONS: locations,
    MY_ACCOUNT: myAccount,
    VERIFIED: verified,
    UNVERIFIED: unverified,

    FAKE_PASSWORD: fakePassword,

    EDIT: editText,
    DELETE: deleteText,
    ADD_LOCATION: addLocation,
    EDIT_LOCATION: editLocation,
    DELETE_LOCATION: deleteLocation,
    TELL_US_WHERE_CALLS: tellUsWhereCalls,
    LOCATION_NAME: locationName,
    PHONE_NUMBER: phoneNumber,
    CODE: code,
    CANCEL: cancel,
    INVALID_LOCATION_CODE: invalidLocationCode,
    FAILED_TO_ADD_LOCATION: failedToAddLocation,
    ADD_CALLING_LOCATION_TITLE: addCallingLocationTitle,
    ADD_CALLING_LOCATION_SUBTITLE: addCallingLocationSubtitle,
    ARE_YOU_SURE_DELETE_LOC_PREFIX: areYouSureDeleteLocPrefix,
    FAILED_TO_DELETE_LOCATION: failedToDeleteLocation,
    UNABLE_TO_DELETE: unableToDelete,
    AS_YOU_ARE_CURRENTLY_REGISTERED: asYouAreCurrentlyRegistered,

    OK: ok,
    PERMISSIONS_ERROR_HEADER: permissionsErrorHeader,
    PERMISSIONS_ERROR_CONTENT: permissionsErrorContent,
    NO_TEAMS_MSG: noTeamsMsg,
    ERROR_RESPONSE_MESSAGE: errorResponseMessage,

    FORGOT_YOUR_PASSWORD: forgotYourPassword,
    FORGOT_YOUR_PASSWORD_ENTER_USERNAME: forgotYourPasswordEnterUsername,
    FORGOT_YOUR_PASSWORD_ENTER_EMAIL: forgotYourPasswordEnterEmail,
    NEXT: next,
    BACK_TO_SIGN_IN: backToSignIn,
    ENTER_DIGIT_CODE: enterDigitCode,
    ENTER_VERIFICATION_CODE: enterVerificationCode,
    INCORRECT_CODE_ENTERED: incorrectCodeEntered,
    FAILED_TO_VALIDATE: failedToValidate,
    VALIDATING_CODE: validatingCode,
    UNABLE_TO_RESET_PW: unableToResetPW,
    UNABLE_TO_RESET_PW_DESC: unableToResetPWDescription,
    TRY_AGAIN: tryAgain,
    FAILED_TO_SAVE: failedToSave,

    GET_STARTED: getStarted,
    WELCOME_DIALOG_SUBTITLE1: welcomeDialogSubtitle1,
    WELCOME_DIALOG_SUBTITLE2: welcomeDialogSubtitle2,
    RESET_PASSWORD: resetPassword,
    RESET_PASSWORD_BUTTON: resetPasswordButton,

    PASSWORD_DOESNT_MATCH_CRITERIA: passwordDoesntMatchCriteria,
    PASSWORD_MUST_MATCH: passwordMustMatch,

    // Location settings email verification
    RESEND_VERIFICATION_EMAIL: resendVerificationEmail,
    VERIFICATION_FAILED: verificationFailed,

    WHY_EMAIL_ADDRESS: whyEmailAddress,
    WHY_EMAIL_ADDRESS_REASON1: whyEmailAddressReason1,
    WHY_EMAIL_ADDRESS_REASON2: whyEmailAddressReason2,
    WHY_EMAIL_ADDRESS_REASON3: whyEmailAddressReason3,
}
